<template>
    <div class="menu">
        <el-menu
                :default-active="path"
                class="el-menu-demo"
                router
                unique-opened
                mode="horizontal"
                background-color="#1C202B"
                text-color="#fff"
                active-text-color="#ffd04b"
                style="width:100%;justify-content: space-between;align-self:center;border-color: #1C202B">
            <template v-for="(menuItem, index) in menu">
                <template v-if="menuItem.children && menuItem.children.length > 0">
                    <el-submenu :key="index" :index="menuItem.path" v-if="!menuItem.hidden">
                        <template slot="title">
                            <i :class="menuItem.meta.icon"></i> {{menuItem.meta.title}}
                        </template>
                        <MenuConponents v-if="menuItem.children" :menu="menuItem.children"></MenuConponents>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :key="index"  :index="menuItem.path">
                        <i :class="menuItem.meta.icon"></i> {{menuItem.meta.title}}
                    </el-menu-item>
                </template>
            </template>



        </el-menu>
    </div>
</template>

<script>
    export default {
        name: "MenuConponents",
        props: {
            menu: {
                type: Array,
                required: true,
                default: () => []
            },
            path: {
                type: String,
                default: "/"
            }

        }
    }
</script>

<style scoped>
    .menu {
        background: #1C202B;
        width: 100%;
        display: flex;
        /*padding: 35px;*/
        justify-content: center;
        /*border: 2px dotted red;*/
        /*border-left-color:  #666;*/
    }

</style>